/*
 * as.if hub - Verhalten (Journey, 25.09.2026 abends).
 * Gehoert zu sections/asif-hub.liquid und assets/asif-hub.css.
 *
 * Insel: Taste "Hilfe". Leiste (Radio laeuft oder Radioseite): Titel oeffnet
 * die Titelkarte, das Fragezeichen die Hilfe, Play rechts.
 * Dialog: Schritt 1 "Wie koennen wir helfen?" mit zwei bis vier Wegen je
 * Seite, Schritt 2 das Thema mit Links und Fragen. Suche ueber die Lupe.
 * Unten immer die Direktwege. Radio im Dialog nur als Hinweis mit Play,
 * ausserhalb der Radioseite und solange nichts laeuft.
 *
 * SPA-Vertrag (asif-spa.js): Der Hub liegt ausserhalb von <main> und wird
 * beim Seitenwechsel nicht neu gebaut. Er hoert auf
 *   document 'asif:page:start'  -> Dialog schliessen
 *   document 'asif:page'        -> Kontext, Seitenfragen und Modus neu bestimmen
 * Aussen genutzt: [data-hub-open] und #asif-hub-panel (asif-footer.js),
 * 'asif:track:open' (Radioseite, Buehne), 'asif:hub' beim Oeffnen und Schliessen.
 */
(() => {
  'use strict';

  const root = document.querySelector('[data-asif-hub]');
  if (!root || root.dataset.hubReady === '1') return;
  root.dataset.hubReady = '1';

  const q = (selector, scope = root) => scope.querySelector(selector);
  const qa = (selector, scope = root) => [...scope.querySelectorAll(selector)];

  const bar = q('[data-hub-bar]');
  const launcher = q('#asif-hub-launcher');
  const helpButton = q('[data-hub-open]');
  const panel = q('#asif-hub-panel');
  const closeButton = q('[data-hub-close]');
  const backButton = q('[data-hub-back]');
  const searchOpenButton = q('[data-hub-search-open]');
  const scrollArea = q('[data-hub-scroll]');
  const heading = q('#asif-hub-title');
  const headingDefault = heading?.textContent || 'Wie können wir helfen?';
  const playButton = q('[data-hub-play]');
  const playLabel = q('[data-hub-play-label]');
  const startView = q('[data-hub-view="start"]');
  const topicView = q('[data-hub-view="topic"]');
  const calendarView = q('[data-hub-view="calendar"]');
  const calendarButton = q('[data-hub-calendar-open]');
  const calendarHost = q('[data-hub-calendar-host]');
  let calendarController = null;
  let calendarAbort = null;
  let calendarModulePromise = null;
  const calendarLoading = q('[data-hub-calendar-loading]');
  const calendarError = q('[data-hub-calendar-error]');
  const calendarStage = q('[data-hub-calendar-stage]');
  let calendarLoadTimer = 0;
  const journeys = qa('[data-hub-journey]');
  const listenButton = q('[data-hub-listen]');
  const listenMeta = q('[data-hub-listen-meta]');
  const card = q('#asif-track-card');
  const cardBody = q('[data-hub-card-body]');
  const cardKicker = q('[data-hub-card-kicker]');
  const volume = q('[data-hub-volume]');
  const volumeInput = q('[data-hub-volume-input]');
  const wayRows = qa('[data-hub-way]');
  const faqList = q('[data-hub-faq-list]');
  const searchBox = q('[data-hub-search-box]');
  const searchInput = q('[data-hub-search]');
  const searchClear = q('[data-hub-search-clear]');
  const statusLine = q('[data-hub-status-line]');
  const moreButton = q('[data-hub-more]');
  const emptyNote = q('[data-hub-empty]');
  const grip = q('[data-hub-grip]');
  const titleNodes = qa('[data-hub-title]');
  const artistNodes = qa('[data-hub-artist]');
  const programNodes = qa('[data-hub-program]');
  const artNodes = qa('[data-hub-art]');
  const progress = q('[data-hub-progress]');
  const progressFill = progress?.firstElementChild || null;
  if (!bar || !helpButton || !panel || !closeButton) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mobileCommerce = window.matchMedia('(max-width: 749px)');
  const sheetQuery = window.matchMedia('(max-width: 39.99rem)');
  const revealOffset = Math.max(0, Number(root.dataset.revealOffset) || 0);
  const VOLUME_KEY = 'asif_radio_volume_v1';

  const radio = {
    hasSession: false,
    isPlaying: false,
    isLoading: false,
    title: 'as.if.radio',
    artist: 'as.if.records',
    program: ''
  };
  let morphTimer = 0;
  let context = { key: 'other' };

  /* --- Seitenkontext ------------------------------------------------- */

  const templateKey = () => document.body.dataset.asifTemplate || '';

  const isRadioPage = () => templateKey() === 'page.asif-radio' || document.body.classList.contains('asif-radio-product');

  // Ein Schluessel je Seitentyp. Er entscheidet, welche Wege Schritt 1 zeigt.
  const resolveContext = () => {
    const path = window.location.pathname.replace(/\/+$/, '') || '/';
    const [name, suffix = ''] = templateKey().split('.');
    if (path === '/pages/spaces' || path === '/pages/as-if-spaces' || suffix === 'as-if-spaces') return { key: 'spaces' };
    if (path === '/pages/spirits' || path === '/pages/as-if-spirits' || suffix === 'as-if-spirits') return { key: 'spirits' };
    if (path === '/pages/schnapskartell' || suffix === 'schnapskartell') return { key: 'schnapskartell' };
    if (path === '/pages/as-if-studio' || path === '/pages/studio' || suffix === 'as-if-studio') return { key: 'studio' };
    if (isRadioPage()) return { key: 'radio' };
    if (path === '/pages/club' || suffix === 'asif-club') return { key: 'club' };
    if (['product', 'collection', 'cart', 'search', 'list-collections', 'customers'].includes(name) || path.startsWith('/collections') || path.startsWith('/products') || path === '/cart' || path === '/pages/ruecksendung' || path.startsWith('/policies')) return { key: 'shop' };
    if (name === 'article' || name === 'blog' || suffix === 'asif-blog' || path.startsWith('/blogs')) return { key: 'blog' };
    if (name === 'index' || path === '/') return { key: 'home' };
    return { key: 'other' };
  };

  const applyContext = () => {
    context = resolveContext();
    journeys.forEach((row) => {
      const targets = (row.dataset.hubContexts || '').split(',').filter(Boolean);
      row.hidden = !targets.includes(context.key);
    });
    if (context.key === 'spaces' && calendarButton) {
      journeys.find((row) => !row.hidden && row.classList.contains('hub__journey--primary'))?.after(calendarButton);
    }
    syncListen();
  };

  /* --- Modus: Insel oder Leiste -------------------------------------- */

  const wantsBar = () => isRadioPage() || radio.hasSession;

  const syncVolumeVisibility = () => {
    if (!volume) return;
    const audio = document.getElementById('rspAudio');
    volume.hidden = !(root.classList.contains('is-bar') && finePointer.matches && audio);
  };

  // Pierre 23.09.2026: Der Player kommt nicht mehr aus der Insel gewachsen
  // (die ist oben auf der Seite ausgeblendet), sondern gleitet vom unteren
  // Rand herein; ist die Insel gerade sichtbar, blendet sie vorher kurz aus.
  // Beim Pausieren gleitet er wieder hinaus, danach kommt die Insel zurueck,
  // sofern man schon unter dem ersten Bildbereich ist. Radioseite: immer Leiste.
  const BAR_IN_MS = 560;
  const BAR_OUT_MS = 400;
  const ISLAND_OUT_MS = 180;
  const ISLAND_BACK_DELAY = 220;
  let islandHoldUntil = 0;
  let modeToken = 0;
  let modeTimer = 0;
  const applyMode = () => {
    const next = wantsBar();
    const current = root.classList.contains('is-bar') && !root.classList.contains('is-bar-leaving');
    if (next !== current) {
      const animate = !reducedMotion.matches && !root.classList.contains('is-instant');
      const token = ++modeToken;
      window.clearTimeout(modeTimer);
      window.clearTimeout(morphTimer);
      root.classList.remove('is-morphing');
      bar.style.transform = '';
      if (!animate) {
        root.classList.remove('is-bar-entering', 'is-bar-leaving', 'is-island-leaving');
        root.classList.toggle('is-bar', next);
        document.documentElement.classList.toggle('asif-hub-bar', next);
      } else if (next) {
        const enter = () => {
          if (token !== modeToken) return;
          root.classList.remove('is-island-leaving', 'is-bar-leaving');
          root.classList.add('is-bar', 'is-bar-entering');
          document.documentElement.classList.add('asif-hub-bar');
          void bar.offsetWidth; // Startlage unter dem Rand festhalten.
          window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
            if (token === modeToken) root.classList.remove('is-bar-entering');
          }));
          applyMode();
        };
        const islandVisible = !root.classList.contains('is-bar') && root.classList.contains('is-ready');
        if (islandVisible) {
          root.classList.add('is-island-leaving');
          modeTimer = window.setTimeout(enter, ISLAND_OUT_MS);
        } else {
          enter();
        }
      } else {
        root.classList.remove('is-bar-entering');
        root.classList.add('is-bar-leaving');
        modeTimer = window.setTimeout(() => {
          if (token !== modeToken) return;
          // Die Insel startet unsichtbar, ohne Ueberblendung aus der Leiste
          // (is-instant), und blendet erst im naechsten Bild ruhig ein.
          islandHoldUntil = performance.now() + ISLAND_BACK_DELAY;
          root.classList.add('is-instant');
          root.classList.remove('is-bar', 'is-bar-leaving', 'is-ready');
          document.documentElement.classList.remove('asif-hub-bar');
          applyMode();
          void bar.offsetWidth;
          root.classList.remove('is-instant');
          // Kurze Pause, dann steigt die Insel ruhig auf. Vorher auch nicht per Scroll.
          window.setTimeout(syncReveal, ISLAND_BACK_DELAY + 16);
        }, BAR_OUT_MS);
        return;
      }
    }
    const shown = root.classList.contains('is-bar') && !root.classList.contains('is-bar-leaving');
    if (playButton) {
      playButton.hidden = !shown;
      playButton.disabled = !shown;
      playButton.tabIndex = shown ? 0 : -1;
    }
    // Titel und Cover der Leiste sind nur in der Leiste bedienbar.
    if (launcher) {
      launcher.hidden = false;
      launcher.disabled = !shown;
      launcher.tabIndex = shown ? 0 : -1;
    }
    syncListen();
    syncVolumeVisibility();
    syncReveal();
  };

  // Pierre 23.09.2026: Der Hub (Insel) kommt auf allen Seiten erst, wenn der
  // erste Bildbereich (Buehne, Slider, Hero) ganz hinter dem Kopf verschwunden
  // ist, und blendet dann ruhig ein (asif-hub.css). Die Player-Leiste bleibt
  // davon unberuehrt. Seiten ohne grossen Einstieg: nach einer halben
  // Bildschirmhoehe. Kann die Seite nicht so weit scrollen, kommt der Hub am Ende.
  // Ein Wert im Editor (reveal_offset > 0) hat Vorrang.
  let revealHero;
  const findRevealHero = () => {
    const marked = document.querySelector('main [data-hub-reveal-after], main [allow-transparent-header]');
    if (marked) return marked;
    const first = document.querySelector('main > .shopify-section:first-child, #main > .shopify-section:first-child');
    return first || null;
  };
  const revealThreshold = () => {
    if (revealOffset > 0) return revealOffset;
    if (revealHero === undefined || (revealHero && !revealHero.isConnected)) revealHero = findRevealHero();
    const viewport = window.innerHeight || 800;
    if (!revealHero) return viewport * 0.5;
    const rect = revealHero.getBoundingClientRect();
    // Ganze Seiten als erste Section sind kein Einstieg: dann halbe Hoehe.
    if (rect.height < viewport * 0.35 || rect.height > viewport * 1.6) return viewport * 0.5;
    const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    return Math.max(0, rect.bottom + window.scrollY - header);
  };
  const pastReveal = () => {
    const room = document.documentElement.scrollHeight - window.innerHeight;
    return window.scrollY >= Math.min(revealThreshold(), room - 8);
  };
  const syncReveal = () => {
    const held = performance.now() < islandHoldUntil && !root.classList.contains('is-bar');
    root.classList.toggle('is-ready', wantsBar() || panel.open || root.classList.contains('is-bar-leaving') || root.classList.contains('is-bar') || (!held && pastReveal()));
  };

  /* --- Radio-Zustand ------------------------------------------------- */

  const setText = (nodes, value) => nodes.forEach((node) => { if (node.textContent !== value) node.textContent = value; node.classList.toggle('asif-wordmark', /^(as\.if\.radio|as\.if\.records)$/.test(value)); });

  // Titelfortschritt (Pierre 23.09.2026): eine CSS-Animation mit der Laufzeit des
  // Titels und negativem Versatz fuer die schon gelaufene Zeit. Kein Takt in JS.
  let progressKey = '';
  const syncProgress = (state = {}, force = false) => {
    if (!progress || !progressFill) return;
    const start = Number(state.trackStartedAt) || 0;
    const end = Number(state.trackEndsAt) || 0;
    const now = Date.now();
    // 26.09.2026 Pierre: Laeuft das Radio, zeigt die Linie auf jeder Seite, wie
    // weit der Titel ist. Auf der Radioseite wie bisher auch ohne Wiedergabe.
    const listening = state.playing === true || state.status === 'playing' || state.wantsToPlay === true;
    const on = (isRadioPage() || listening) && start > 0 && end > start && now < end + 60000;
    progress.classList.toggle('is-on', on);
    if (!on) { progressKey = ''; return; }
    const key = `${start}:${end}`;
    if (key === progressKey && !force) return;
    const fresh = key !== progressKey;
    progressKey = key;
    progressFill.style.animation = 'none';
    void progressFill.offsetWidth;
    progressFill.style.animation = `hub-progress ${end - start}ms linear ${-(now - start)}ms both`;
    if (fresh) {
      progress.classList.remove('is-fresh');
      void progress.offsetWidth;
      progress.classList.add('is-fresh');
    }
  };

  const syncRadio = (state = {}) => {
    syncProgress(state);
    const status = state.status || 'idle';
    radio.isPlaying = state.playing === true || status === 'playing';
    radio.isLoading = state.loading === true || ['connecting', 'buffering', 'retrying', 'offline'].includes(status) || (status === 'paused' && state.wantsToPlay === true);
    // Sitzung nur, solange das Radio laufen will. Pause baut die Leiste zur Insel zurueck.
    radio.hasSession = state.wantsToPlay === true || state.wanted === true || radio.isPlaying || radio.isLoading
      || state.needsResume === true;
    radio.title = state.title || 'as.if.radio';
    radio.artist = state.artist || 'as.if.records';
    const program = state.program || 'as.if.radio';
    radio.program = state.program || '';
    const statusText = radio.isLoading ? 'Radio verbindet'
      : state.error ? 'Radioverbindung prüfen'
        : state.needsResume ? 'Radio wartet auf Weiterhören'
          : radio.isPlaying ? `Radio spielt: ${radio.artist} - ${radio.title}`
            : 'Radio pausiert';

    // "Radio an" neben Play, solange nichts laeuft: der eine Aufruf in der Leiste.
    const playText = radio.isPlaying || radio.isLoading ? ''
      : state.error ? 'Erneut versuchen'
        : state.needsResume ? 'Weiterhören'
          : status === 'paused' ? 'Weiterhören'
            : 'Radio an';
    if (playLabel) {
      playLabel.hidden = !playText;
      if (playText && playLabel.textContent !== playText) playLabel.textContent = playText;
    }
    playButton?.classList.toggle('has-label', Boolean(playText));
    if (card?.open) renderCard(state);
    root.classList.toggle('has-radio-session', radio.hasSession);
    root.classList.toggle('is-radio-playing', radio.isPlaying);
    root.classList.toggle('is-radio-loading', radio.isLoading);
    setText(titleNodes, radio.title);
    setText(artistNodes, radio.artist);
    setText(programNodes, program);
    root.dataset.radioStatus = statusText;
    artNodes.forEach((image) => {
      if (!state.artworkUrl || image.src === state.artworkUrl) return;
      image.src = state.artworkUrl;
      image.alt = '';
    });
    launcher?.setAttribute('aria-label', `Titelkarte öffnen: ${radio.artist} - ${radio.title}`);
    applyMode();
  };

  /* --- Lautstaerke --------------------------------------------------- */

  let volumeBound = false;
  const setupVolume = () => {
    if (!volume || !volumeInput || volumeBound) return;
    const audio = document.getElementById('rspAudio');
    if (!audio) return;
    // Wird aus zwei Pfaden gerufen (beim Start und wenn der Player meldet, dass
    // er steht). Ohne diese Sperre haengen die Regler-Listener doppelt.
    volumeBound = true;
    const read = () => {
      try {
        const raw = window.localStorage.getItem(VOLUME_KEY);
        // Ein neuer Browser liefert null. Number(null) waere 0: stummer Erststart.
        if (raw === null || raw.trim() === '') return null;
        const stored = Number(raw);
        return Number.isFinite(stored) && stored >= 0 && stored <= 1 ? stored : null;
      } catch { return null; }
    };
    const write = (value) => { try { window.localStorage.setItem(VOLUME_KEY, String(value)); } catch {} };
    const reflect = (value) => {
      const percent = Math.round(value * 100);
      if (Number(volumeInput.value) !== percent) volumeInput.value = String(percent);
      volumeInput.setAttribute('aria-valuetext', `${percent} Prozent`);
    };
    // Auf Touchgeraeten ist der Regler verborgen; dort gilt die Geraetelautstaerke.
    // Keine gespeicherte Desktop-Stummschaltung ohne erreichbaren Regler anwenden.
    const stored = finePointer.matches ? read() : null;
    if (stored !== null) {
      try { audio.volume = stored; } catch {}
    }
    reflect(audio.volume);
    volumeInput.addEventListener('input', () => {
      const next = Math.min(1, Math.max(0, Number(volumeInput.value) / 100));
      audio.volume = next;
      audio.muted = false;
      write(next);
      reflect(next);
    });
    audio.addEventListener('volumechange', () => reflect(audio.muted ? 0 : audio.volume));
    syncVolumeVisibility();
  };


  /* --- Dialog, Teil 1: Seitenfragen, Suche, Themen ---------------------- */

  // Fragen aus dem Abschnitt #faq der Seite (Spirits, Studio ...) werden zum
  // Thema "page". Einmal pro Seite gelesen, nach weichem Wechsel neu.
  let harvestedFor = '';
  let pageFaqCount = 0;
  const plusGlyph = q('.hub__faq-plus');
  const harvestPageFaq = () => {
    if (!faqList) return;
    const sources = [...document.querySelectorAll('main #faq details')].slice(0, 16);
    const key = `${window.location.pathname}|${sources.length}`;
    if (harvestedFor === key) return;
    harvestedFor = key;
    qa('[data-hub-page-faq]', faqList).forEach((node) => node.remove());
    const fragment = document.createDocumentFragment();
    pageFaqCount = 0;
    sources.forEach((source) => {
      const summary = source.querySelector(':scope > summary');
      const question = summary?.textContent.replace(/\s+/g, ' ').trim();
      if (!question) return;
      const item = document.createElement('details');
      item.className = 'hub__faq-item';
      item.hidden = true;
      item.dataset.hubFaq = '';
      item.dataset.hubCategory = 'page';
      item.dataset.hubPageFaq = '';
      item.dataset.hubKeywords = '';
      const head = document.createElement('summary');
      head.className = 'hub__faq-summary';
      const label = document.createElement('span');
      label.className = 'hub__faq-question';
      label.dataset.hubQuestion = '';
      label.textContent = question;
      head.append(label);
      if (plusGlyph) head.append(plusGlyph.cloneNode(true));
      const answer = document.createElement('div');
      answer.className = 'hub__faq-answer';
      [...source.childNodes].forEach((node) => { if (node !== summary) answer.append(node.cloneNode(true)); });
      answer.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      answer.querySelectorAll('script, style, form, iframe, svg').forEach((node) => node.remove());
      item.append(head, answer);
      fragment.append(item);
      pageFaqCount += 1;
    });
    faqList.prepend(fragment);
  };

  const faqItems = () => qa('[data-hub-faq]', faqList || root);

  const STOP = new Set(['ich', 'wie', 'was', 'kann', 'konnen', 'der', 'die', 'das', 'den', 'dem', 'ein', 'eine', 'einen', 'mein', 'meine', 'meinen', 'ist', 'wo', 'wann', 'zu', 'mit', 'und', 'oder', 'fur', 'auf', 'es', 'du', 'man', 'gibt', 'bei', 'von', 'im', 'in', 'an', 'am', 'noch', 'habe', 'hab', 'sind', 'wir', 'ihr', 'euch', 'ihr', 'mir', 'mich', 'uns', 'bitte', 'hallo', 'hi', 'wieso', 'warum', 'welche', 'welcher', 'welches', 'gibts', 'geht', 'wird', 'werden', 'hat', 'haben', 'nicht', 'kein', 'keine', 'so', 'auch', 'da', 'dass', 'lauft', 'gerade', 'etwas', 'mal']);
  const normalize = (value) => String(value || '')
    .toLowerCase()
    .replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss')
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u')
    .replace(/[^a-z0-9%]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  const tokensOf = (value) => {
    const all = normalize(value).split(' ').filter((token) => token.length > 1);
    const meaningful = all.filter((token) => !STOP.has(token));
    return meaningful.length ? meaningful : all;
  };
  const wordsOf = (value) => normalize(value).split(' ');
  const hitIn = (words, joined, token) => words.some((word) => word.startsWith(token)) || (token.length >= 4 && joined.includes(token));

  const indexCache = new WeakMap();
  const indexOf = (node, parts) => {
    let entry = indexCache.get(node);
    if (!entry) {
      entry = parts.map((text) => ({ words: wordsOf(text), joined: normalize(text) }));
      indexCache.set(node, entry);
    }
    return entry;
  };
  // Wenige Wortfamilien, die in Fragen anders heissen als in Antworten.
  const RELATED = [
    ['lange', 'dauer', 'dauert', 'zeit', 'stunden'],
    ['kosten', 'kostet', 'preis', 'preise', 'teuer', 'euro'],
    ['zuruck', 'ruckgabe', 'retoure', 'umtausch', 'widerruf'],
    ['lieferung', 'versand', 'liefern', 'porto', 'lieferzeit'],
    ['buchen', 'anfrage', 'anfragen', 'reservieren', 'termin'],
    ['song', 'titel', 'track', 'lied'],
    ['konto', 'club', 'anmelden', 'login']
  ];
  const variantsOf = (token) => {
    if (token.length < 4) return [token];
    const group = RELATED.find((words) => words.some((word) => word.startsWith(token) || token.startsWith(word)));
    return group ? [token, ...group.filter((word) => word !== token)] : [token];
  };
  const scoreOf = (tokens, fields, weights) => {
    let score = 0;
    let matched = 0;
    tokens.forEach((token) => {
      let best = 0;
      variantsOf(token).forEach((variant, position) => {
        const factor = position === 0 ? 1 : 0.6;
        fields.forEach((field, index) => {
          const hit = position === 0 ? hitIn(field.words, field.joined, variant) : field.words.some((word) => word.startsWith(variant));
          if (hit) best = Math.max(best, weights[index] * factor);
        });
      });
      if (best) matched += 1;
      score += best;
    });
    const needed = Math.max(1, Math.ceil(tokens.length / 2));
    return matched >= needed ? score + matched * 2 : 0;
  };

  const escapeHtml = (value) => value.replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const highlight = (node, tokens) => {
    if (!node.dataset.hubText) node.dataset.hubText = node.textContent;
    const text = node.dataset.hubText;
    if (!tokens.length) { node.textContent = text; return; }
    // Markiert Wortanfaenge, die einem Suchwort entsprechen (Umlaute beachtet).
    const html = text.split(/(\s+)/).map((part) => {
      if (!part.trim()) return escapeHtml(part);
      const plain = normalize(part);
      const token = tokens.find((candidate) => plain.startsWith(candidate));
      if (!token) return escapeHtml(part);
      // Laenge im Original ungefaehr uebertragen: ganze Wortteile bis zur Tokenlaenge.
      let cut = 0;
      let seen = '';
      while (cut < part.length && normalize(seen).length < token.length) { seen += part[cut]; cut += 1; }
      return `<mark>${escapeHtml(part.slice(0, cut))}</mark>${escapeHtml(part.slice(cut))}`;
    }).join('');
    node.innerHTML = html;
  };


  /* --- Dialog, Teil 2: Schritte ------------------------------------------ */

  // Ein Blatt, zwei Schritte: 'start' (Wege) und 'topic' (Thema oder Suche).
  const TOPIC_LIMIT = 6;
  let step = 'start';
  let currentTopic = '';
  let searching = false;
  let searchQuery = '';

  const setHeading = (text) => {
    if (!heading) return;
    heading.textContent = text;
    heading.classList.toggle('asif-wordmark', /^(as\.if\.radio|as\.if\.records)$/.test(text));
  };

  const showStep = (next, { focus = true } = {}) => {
    const forward = next !== 'start';
    step = next;
    if (startView) startView.hidden = forward;
    if (topicView) topicView.hidden = next !== 'topic';
    if (calendarView) calendarView.hidden = next !== 'calendar';
    if (backButton) backButton.hidden = !forward;
    if (searchOpenButton) searchOpenButton.hidden = searching || next === 'calendar';
    panel.dataset.step = next;
    if (next === 'calendar') startCalendar();
    else stopCalendar();
    if (!reducedMotion.matches) {
      const view = next === 'calendar' ? calendarView : forward ? topicView : startView;
      view?.classList.remove('is-entering', 'is-returning');
      void view?.offsetWidth;
      view?.classList.add(forward ? 'is-entering' : 'is-returning');
    }
    if (scrollArea) scrollArea.scrollTop = 0;
    if (!focus) return;
    window.requestAnimationFrame(() => {
      if (searching && finePointer.matches && !sheetQuery.matches) searchInput?.focus({ preventScroll: true });
      else heading?.focus({ preventScroll: true });
    });
  };

  const resetList = () => {
    wayRows.forEach((row) => { row.hidden = true; row.style.order = ''; });
    faqItems().forEach((item) => {
      item.hidden = true;
      item.open = false;
      item.style.order = '';
      const label = item.querySelector('[data-hub-question]');
      if (label) highlight(label, []);
    });
    if (moreButton) moreButton.hidden = true;
    if (emptyNote) emptyNote.hidden = true;
    if (statusLine) statusLine.textContent = '';
  };

  // Thema zeigen: erst die Links (was man tun kann), dann die Fragen.
  const renderTopic = (topic, { expand = false } = {}) => {
    resetList();
    let key = topic;
    // Ohne Fragen auf der Seite: bei Orten Raeume & Kurse, sonst Etwas anderes.
    const pageFallback = () => (['spaces', 'spirits', 'studio'].includes(context.key) ? 'spaces' : 'general');
    if (key === 'page' && pageFaqCount === 0) key = pageFallback();
    // Was im ersten Schritt schon als Weg steht (etwa "Raum anfragen"), nicht doppelt zeigen.
    const shownJourneys = new Set(journeys.filter((row) => !row.hidden && row.href).map((row) => row.href));
    wayRows.forEach((row) => {
      const topics = (row.dataset.hubTopics || '').split(',');
      row.hidden = !topics.includes(key) || shownJourneys.has(row.href);
    });
    let shown = 0;
    let total = 0;
    faqItems().forEach((item) => {
      if (item.dataset.hubCategory !== key) return;
      total += 1;
      if (expand || shown < TOPIC_LIMIT) { item.hidden = false; shown += 1; }
    });
    if (moreButton) {
      moreButton.hidden = total <= shown;
      moreButton.textContent = `Weitere ${total - shown} Fragen`;
    }
  };

  const openTopic = (topic, title) => {
    searching = false;
    currentTopic = topic;
    if (searchBox) searchBox.hidden = true;
    setHeading(title || headingDefault);
    renderTopic(topic);
    showStep('topic');
  };

  const openSearch = () => {
    searching = true;
    currentTopic = '';
    if (searchBox) searchBox.hidden = false;
    if (searchInput) searchInput.value = '';
    setHeading('Suchen');
    renderSearch();
    showStep('topic');
    // Am Handy erst auf Tippen in das Feld, sonst verdeckt die Tastatur alles.
    if (!sheetQuery.matches) window.requestAnimationFrame(() => searchInput?.focus({ preventScroll: true }));
  };

  const goStart = ({ focus = true } = {}) => {
    searching = false;
    currentTopic = '';
    searchQuery = '';
    if (searchInput) searchInput.value = '';
    if (searchBox) searchBox.hidden = true;
    setHeading(headingDefault);
    resetList();
    refreshChannelLinks();
    showStep('start', { focus });
  };

  // Suche ueber alle Fragen und Links, schwache Treffer fallen weg.
  const renderSearch = () => {
    searchQuery = (searchInput?.value || '').trim();
    if (searchClear) searchClear.hidden = !searchQuery;
    refreshChannelLinks();
    resetList();
    if (!searchQuery) return;
    const tokens = tokensOf(searchQuery);
    const ways = wayRows
      .map((row) => ({ row, score: scoreOf(tokens, indexOf(row, [row.querySelector('.hub__way-title')?.textContent || '', row.dataset.hubKeywords || '', row.querySelector('.hub__way-meta')?.textContent || '']), [6, 4, 2]) }))
      .filter((entry) => entry.score > 0)
      .sort((a, b) => b.score - a.score);
    const wayFloor = ways.length ? ways[0].score * 0.6 : 0;
    const topWays = ways.filter((entry) => entry.score >= wayFloor).slice(0, 2);
    topWays.forEach(({ row }, index) => { row.hidden = false; row.style.order = String(index); });

    const ranked = [];
    faqItems().forEach((item) => {
      const label = item.querySelector('[data-hub-question]');
      const question = label?.dataset.hubText || label?.textContent || '';
      const answer = item.querySelector('.hub__faq-answer')?.textContent || '';
      const score = scoreOf(tokens, indexOf(item, [question, item.dataset.hubKeywords || '', answer]), [6, 4, 2]);
      if (score > 0) ranked.push({ item, score, label });
    });
    ranked.sort((a, b) => b.score - a.score);
    const floor = ranked.length ? ranked[0].score * 0.55 : 0;
    const strong = ranked.filter((entry) => entry.score >= floor).slice(0, 6);
    strong.forEach(({ item, label }, index) => {
      item.hidden = false;
      item.style.order = String(index);
      if (label) highlight(label, tokens);
    });
    const found = strong.length + topWays.length;
    if (statusLine) statusLine.textContent = found ? (found === 1 ? '1 Treffer' : `${found} Treffer`) : '';
    if (emptyNote) emptyNote.hidden = found > 0;
  };

  searchInput?.addEventListener('input', renderSearch);
  searchInput?.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    const firstWay = wayRows.find((row) => !row.hidden);
    if (firstWay) { firstWay.focus(); return; }
    const first = faqItems().filter((item) => !item.hidden).sort((a, b) => Number(a.style.order || 0) - Number(b.style.order || 0))[0];
    if (first) { first.open = true; first.querySelector('summary')?.focus(); }
  });
  searchClear?.addEventListener('click', () => {
    if (!searchInput) return;
    searchInput.value = '';
    renderSearch();
    searchInput.focus();
  });
  moreButton?.addEventListener('click', () => {
    const firstHidden = faqItems().find((item) => item.hidden && item.dataset.hubCategory === (currentTopic === 'page' && pageFaqCount === 0 ? (['spaces', 'spirits', 'studio'].includes(context.key) ? 'spaces' : 'general') : currentTopic));
    renderTopic(currentTopic, { expand: true });
    firstHidden?.querySelector('summary')?.focus({ preventScroll: true });
  });
  journeys.forEach((row) => {
    if (!row.dataset.hubTopic) return;
    row.addEventListener('click', () => openTopic(row.dataset.hubTopic, row.dataset.hubTopicTitle));
  });
  function stopCalendar() {
    window.clearTimeout(calendarLoadTimer);
    calendarAbort?.abort();
    calendarAbort = null;
    calendarController?.destroy();
    calendarController = null;
    calendarHost?.replaceChildren();
    if (calendarLoading) calendarLoading.hidden = true;
    if (calendarError) calendarError.hidden = true;
    calendarStage?.setAttribute('aria-busy', 'false');
  }
  function calendarFailed() {
    stopCalendar();
    if (calendarError) calendarError.hidden = false;
  }
  function loadCalendarModule() {
    if (window.AsIfAvailabilityCalendar) return Promise.resolve();
    if (calendarModulePromise) return calendarModulePromise;
    calendarModulePromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = calendarView.dataset.calendarModule;
      script.onload = resolve;
      script.onerror = () => { script.remove(); calendarModulePromise = null; reject(new Error('calendar module unavailable')); };
      document.head.append(script);
    });
    return calendarModulePromise;
  }
  function startCalendar() {
    if (!calendarHost || calendarController || calendarAbort) return;
    const request = new AbortController();
    calendarAbort = request;
    if (calendarLoading) calendarLoading.hidden = false;
    if (calendarError) calendarError.hidden = true;
    calendarStage?.setAttribute('aria-busy', 'true');
    calendarLoadTimer = window.setTimeout(calendarFailed, 12000);
    Promise.all([
      loadCalendarModule(),
      fetch(calendarView.dataset.calendarUrl, { credentials: 'same-origin', signal: request.signal }).then((response) => {
        if (!response.ok) throw new Error('calendar unavailable');
        return response.text();
      })
    ]).then(([, html]) => {
      if (request.signal.aborted || step !== 'calendar' || !panel.open) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const page = parsed.querySelector('.cal-page--widget');
      const style = page?.previousElementSibling;
      if (!page || style?.tagName !== 'STYLE' || !window.AsIfAvailabilityCalendar) throw new Error('calendar markup unavailable');
      calendarHost.replaceChildren(style, page);
      calendarController = window.AsIfAvailabilityCalendar.mount(page);
      window.clearTimeout(calendarLoadTimer);
      calendarLoading.hidden = true;
      calendarStage.setAttribute('aria-busy', 'false');
    }).catch((error) => {
      if (!request.signal.aborted) calendarFailed();
    });
  }
  calendarButton?.addEventListener('click', () => {
    if (context.key !== 'spaces') return;
    searching = false;
    currentTopic = '';
    setHeading(calendarButton.querySelector('.hub__journey-title')?.textContent || headingDefault);
    showStep('calendar');
  });
  backButton?.addEventListener('click', () => goStart());
  searchOpenButton?.addEventListener('click', openSearch);

  /* --- Radio im Dialog: nur ein Hinweis mit Play ------------------------- */
  // Pierre 25.09.2026: kein Player im Hub, dafuer gibt es die Leiste. Nur
  // ausserhalb der Radioseite und solange nichts laeuft, ein Hinweis mit Play.
  const syncListen = () => {
    if (!listenButton) return;
    listenButton.hidden = isRadioPage() || radio.hasSession;
    if (listenMeta) {
      const text = radio.program && radio.program !== 'as.if.radio' ? `Läuft gerade: ${radio.program}` : 'Live, rund um die Uhr';
      if (listenMeta.textContent !== text) listenMeta.textContent = text;
    }
  };
  // Nach dem Tippen auf Play schliesst der Dialog, damit man die Leiste sieht.
  listenButton?.addEventListener('click', () => window.setTimeout(() => closePanel(), 0));

  /* --- Dialog ---------------------------------------------------------- */

  const focusables = () => qa('a[href], button:not([disabled]), summary, input', panel)
    .filter((element) => !element.hidden && element.getClientRects().length && !element.closest('[hidden]'));

  const refreshChannelLinks = () => {
    const page = `${document.title}\n${window.location.href}`;
    const question = searchQuery ? `Meine Frage: ${searchQuery}` : '';
    qa('[data-hub-channel="whatsapp"]').forEach((link) => {
      const message = [link.dataset.hubMessage, question, page].filter(Boolean).join('\n\n');
      link.href = `https://wa.me/${link.dataset.hubNumber}?text=${encodeURIComponent(message)}`;
    });
    qa('[data-hub-channel="email"]').forEach((link) => {
      const subject = link.dataset.hubSubject || root.dataset.emailSubject || 'Anfrage über as.if.records';
      link.href = `mailto:${link.dataset.hubAddress}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent([question, page].filter(Boolean).join('\n\n'))}`;
    });
  };

  const openPanel = () => {
    if (panel.open || root.classList.contains('is-consent-blocked')) return;
    applyContext();
    harvestPageFaq();
    goStart({ focus: false });
    helpButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('asif-message-hub-open');
    panel.style.transform = '';
    panel.showModal();
    syncReveal();
    syncCommerce();
    window.requestAnimationFrame(() => {
      if (scrollArea) scrollArea.scrollTop = 0;
      heading?.focus({ preventScroll: true });
    });
    document.dispatchEvent(new CustomEvent('asif:hub', { detail: { state: 'open' } }));
  };

  const closePanel = () => { if (panel.open) panel.close(); };

  // Escape und Zurueck-Geste: erst Antwort zu, dann ein Schritt zurueck, dann schliessen.
  const backOrClose = () => {
    const openFaq = panel.querySelector('.hub__faq-item[open]');
    if (searching && searchInput?.value && document.activeElement === searchInput) {
      searchInput.value = '';
      renderSearch();
    } else if (openFaq) {
      openFaq.open = false;
      openFaq.querySelector('summary')?.focus({ preventScroll: true });
    } else if (step !== 'start') {
      goStart();
    } else {
      closePanel();
    }
  };

  const onPanelClosed = () => {
    helpButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('asif-message-hub-open');
    panel.style.transform = '';
    panel.classList.remove('is-dragging');
    goStart({ focus: false });
    syncReveal();
    syncCommerce();
    if (!root.classList.contains('is-consent-blocked') && !root.classList.contains('is-commerce-obscured')) {
      helpButton.focus({ preventScroll: true });
    }
    document.dispatchEvent(new CustomEvent('asif:hub', { detail: { state: 'closed' } }));
  };

  helpButton.addEventListener('click', openPanel);
  closeButton.addEventListener('click', closePanel);
  panel.addEventListener('close', onPanelClosed);
  panel.addEventListener('click', (event) => { if (event.target === panel) closePanel(); });
  panel.addEventListener('cancel', (event) => { event.preventDefault(); backOrClose(); });
  panel.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      backOrClose();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = focusables();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || active === heading || !panel.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  // Immer nur eine Antwort offen, die geoeffnete ruhig ins Bild holen.
  panel.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.matches('[data-hub-faq]') || !item.open) return;
    faqItems().forEach((other) => { if (other !== item && other.open) other.open = false; });
    window.requestAnimationFrame(() => {
      if (!scrollArea) return;
      const box = scrollArea.getBoundingClientRect();
      const rect = item.getBoundingClientRect();
      if (rect.bottom > box.bottom - 8) scrollArea.scrollBy({ top: Math.min(rect.bottom - box.bottom + 16, rect.top - box.top - 16), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    });
  }, true);

  // Links auf dieselbe Seite (zum Beispiel #anfrage) schliessen den Dialog,
  // damit das Ziel frei ist. Andere Links: der weiche Wechsel schliesst ihn.
  panel.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank') return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch { return; }
    if (url.origin === window.location.origin && url.pathname.replace(/\/+$/, '') === window.location.pathname.replace(/\/+$/, '') && url.hash) closePanel();
  });

  /* --- Tastatur am Handy: Blatt bleibt ueber der Tastatur ---------------- */
  const syncKeyboard = () => {
    const viewport = window.visualViewport;
    if (!viewport || !panel.open || !sheetQuery.matches) { document.documentElement.style.removeProperty('--hub-keyboard'); return; }
    const covered = Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop));
    document.documentElement.style.setProperty('--hub-keyboard', covered > 80 ? `${covered}px` : '0px');
  };
  window.visualViewport?.addEventListener('resize', syncKeyboard, { passive: true });
  panel.addEventListener('close', syncKeyboard);

  /* --- Blatt am Handy nach unten wegziehen ------------------------------ */
  // Nur Griff und Kopf, damit das Scrollen im Inhalt ungestoert bleibt.
  const dragZone = [grip, q('.hub__head', panel)].filter(Boolean);
  let drag = null;
  const endDrag = (event) => {
    if (!drag) return;
    const distance = Math.max(0, event.clientY - drag.startY);
    const speed = distance / Math.max(1, performance.now() - drag.startAt);
    panel.classList.remove('is-dragging');
    drag = null;
    if (distance > 96 || (distance > 32 && speed > 0.6)) {
      panel.style.transform = `translateY(${distance}px)`;
      panel.classList.add('is-leaving');
      window.setTimeout(() => { panel.classList.remove('is-leaving'); closePanel(); }, reducedMotion.matches ? 0 : 180);
    } else {
      panel.style.transform = '';
    }
  };
  dragZone.forEach((zone) => {
    zone.addEventListener('pointerdown', (event) => {
      if (!sheetQuery.matches || event.pointerType === 'mouse' || event.target.closest('button, a, input')) return;
      drag = { startY: event.clientY, startAt: performance.now(), id: event.pointerId };
      panel.classList.add('is-dragging');
      try { zone.setPointerCapture?.(event.pointerId); } catch {}
    });
    zone.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.id) return;
      const distance = Math.max(0, event.clientY - drag.startY);
      panel.style.transform = distance ? `translateY(${distance}px)` : '';
    });
    zone.addEventListener('pointerup', endDrag);
    zone.addEventListener('pointercancel', endDrag);
  });

  /* --- Consent, Kaufknoepfe, Vorschauleiste --------------------------- */

  const isVisible = (element) => Boolean(element && !element.hidden && element.getClientRects().length);

  const syncConsent = () => {
    const banner = document.getElementById('shopify-pc__banner');
    const prefs = document.getElementById('shopify-pc__prefs');
    const blocked = isVisible(banner) || isVisible(prefs);
    root.classList.toggle('is-consent-blocked', blocked);
    if (blocked && panel.open) closePanel();
  };
  const consentObserver = new MutationObserver(syncConsent);
  const observeConsent = () => {
    ['shopify-pc__banner', 'shopify-pc__prefs'].forEach((id) => {
      const element = document.getElementById(id);
      if (!element || element.dataset.hubObserved === '1') return;
      element.dataset.hubObserved = '1';
      consentObserver.observe(element, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    });
  };
  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('#shopify-pc__banner, #shopify-pc__prefs')) return;
    window.setTimeout(() => { observeConsent(); syncConsent(); }, 180);
  }, true);
  const bodyObserver = new MutationObserver(() => { observeConsent(); syncConsent(); });
  bodyObserver.observe(document.body, { childList: true });
  window.setTimeout(() => bodyObserver.disconnect(), 6000);

  // Kaufleiste am unteren Rand (Produktseite, Handy): Taste darueber setzen.
  let stickyFrame = 0;
  const syncStickyOffset = () => {
    stickyFrame = 0;
    let offset = 0;
    if (!root.classList.contains('is-bar')) {
      const vh = window.innerHeight;
      document.querySelectorAll('product-sticky-bar, .product-sticky-bar, [data-pdp-sticky]').forEach((node) => {
        if (!node.getClientRects().length || getComputedStyle(node).visibility === 'hidden') return;
        const rect = node.getBoundingClientRect();
        // Unten am Rand und rechts unter der Taste (Handy: volle Breite, Desktop: Kasten rechts).
        const nearBottom = rect.top < vh && rect.bottom >= vh - 48;
        const underButton = rect.right > window.innerWidth - 240;
        if (rect.height > 0 && rect.height < vh / 2 && nearBottom && underButton) offset = Math.max(offset, Math.ceil(vh - rect.top) - 4);
      });
    }
    document.documentElement.style.setProperty('--hub-sticky-offset', `${offset}px`);
  };
  let stickyLate = 0;
  const scheduleSticky = () => {
    if (!stickyFrame) stickyFrame = window.requestAnimationFrame(syncStickyOffset);
    // Die Kaufleiste faehrt animiert herein: nach dem Scrollen einmal nachmessen.
    window.clearTimeout(stickyLate);
    stickyLate = window.setTimeout(() => window.requestAnimationFrame(syncStickyOffset), 450);
  };
  document.addEventListener('transitionend', (event) => {
    if (event.target instanceof Element && event.target.matches('product-sticky-bar, .product-sticky-bar, [data-pdp-sticky]')) scheduleSticky();
  }, true);
  window.addEventListener('scroll', scheduleSticky, { passive: true });
  window.addEventListener('resize', scheduleSticky, { passive: true });
  document.addEventListener('asif:page', () => window.setTimeout(scheduleSticky, 60));
  window.setTimeout(scheduleSticky, 300);

  const commerceInView = new Set();
  let commerceObserver = null;
  const syncCommerce = () => {
    const obscure = mobileCommerce.matches && commerceInView.size > 0 && !panel.open && !wantsBar();
    root.classList.toggle('is-commerce-obscured', obscure);
    helpButton.disabled = obscure;
  };
  const watchCommerce = () => {
    commerceObserver?.disconnect();
    commerceInView.clear();
    const targets = [...document.querySelectorAll('main buy-buttons, main .shopify-payment-button')].filter((node) => !node.closest('product-sticky-bar'));
    if (!targets.length) { syncCommerce(); return; }
    commerceObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.05) commerceInView.add(entry.target);
        else commerceInView.delete(entry.target);
      });
      syncCommerce();
    }, { threshold: [0, 0.05, 1] });
    targets.forEach((target) => commerceObserver.observe(target));
  };
  mobileCommerce.addEventListener?.('change', syncCommerce);

  let previewBar = null;
  let previewObserver = null;
  const syncPreview = () => {
    const next = document.getElementById('PBarNextFrameWrapper');
    if (next !== previewBar) {
      previewObserver?.disconnect();
      previewBar = next;
      if (previewBar && 'ResizeObserver' in window) {
        previewObserver = new ResizeObserver(syncPreview);
        previewObserver.observe(previewBar);
      }
    }
    let offset = 0;
    if (previewBar) {
      const rect = previewBar.getBoundingClientRect();
      if (rect.height > 0 && rect.bottom >= window.innerHeight - 1 && rect.top < window.innerHeight) offset = Math.ceil(window.innerHeight - rect.top);
    }
    document.documentElement.style.setProperty('--hub-preview-offset', `${offset}px`);
  };
  const previewWatcher = new MutationObserver(syncPreview);
  previewWatcher.observe(document.body, { childList: true });
  window.addEventListener('resize', syncPreview, { passive: true });

  /* --- Der Platz unten in der installierten App -------------------------- */
  const standalone = () => window.matchMedia?.('(display-mode: standalone)').matches === true
    || window.matchMedia?.('(display-mode: fullscreen)').matches === true
    || window.navigator.standalone === true;

  // Keep only insets actually reported by this viewport. Screen-size guesses
  // confuse iPad, Android and home-button devices; portrait and landscape differ.
  const safeBottomByViewport = new Map();
  const safeProbe = document.createElement('div');
  safeProbe.setAttribute('aria-hidden', 'true');
  safeProbe.style.cssText = 'position:fixed;left:0;bottom:0;width:1px;pointer-events:none;visibility:hidden;height:env(safe-area-inset-bottom,0px);';
  document.body.append(safeProbe);
  const syncStandaloneInset = () => {
    const html = document.documentElement;
    const installed = standalone();
    html.classList.toggle('asif-standalone-inset', installed);
    if (!installed) {
      html.style.setProperty('--hub-measured-safe-bottom', '0px');
      return;
    }
    const orientation = window.screen?.orientation?.type
      || (window.matchMedia?.('(orientation: landscape)').matches ? 'landscape' : 'portrait');
    // Include layout width: iPad split-screen has its own geometry. Do not key on
    // visualViewport height, which changes as the keyboard/browser UI moves.
    const key = `${orientation}:${Math.round(document.documentElement.clientWidth)}`;
    const measured = Math.max(0, safeProbe.getBoundingClientRect().height);
    const safe = Math.max(measured, safeBottomByViewport.get(key) || 0);
    safeBottomByViewport.set(key, safe);
    // Preserve the existing iPhone protection during WebKit's initial zero report.
    // This narrow compatibility fallback is not used for iPad/Android and retires
    // as soon as this viewport has supplied a positive native measurement.
    const shortSide = Math.min(window.screen?.width || 0, window.screen?.height || 0);
    const longSide = Math.max(window.screen?.width || 0, window.screen?.height || 0);
    const iphoneBootstrap = /iPhone/.test(window.navigator.userAgent || '') && shortSide >= 375 && longSide >= 812;
    const fallback = iphoneBootstrap && !safe ? (orientation.startsWith('landscape') ? 21 : 34) : 0;
    html.style.setProperty('--hub-measured-safe-bottom', `${safe || fallback}px`);
  };
  let insetFrame = 0;
  const scheduleStandaloneInset = () => {
    if (insetFrame) return;
    insetFrame = window.requestAnimationFrame(() => {
      insetFrame = 0;
      syncStandaloneInset();
    });
  };
  syncStandaloneInset();
  if ('ResizeObserver' in window) new ResizeObserver(scheduleStandaloneInset).observe(safeProbe);
  window.addEventListener('resize', scheduleStandaloneInset, { passive: true });
  window.addEventListener('orientationchange', scheduleStandaloneInset, { passive: true });
  window.addEventListener('pageshow', scheduleStandaloneInset);
  window.visualViewport?.addEventListener('resize', scheduleStandaloneInset, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') scheduleStandaloneInset();
  });
  ['standalone', 'fullscreen'].forEach((mode) => {
    window.matchMedia?.(`(display-mode: ${mode})`).addEventListener?.('change', scheduleStandaloneInset);
  });

  /* --- Titelkarte: ausschließlich Details und Aktionen für einen Titel ---------- */
  let cardTrackId = '';
  let cardSource = 'current';
  let cardOpener = null;
  let cardTrackSnapshot = null;

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) { node.textContent = text; node.classList.toggle('asif-wordmark', /^(as\.if\.radio|as\.if\.records)$/.test(text)); }
    return node;
  };
  const glyph = (name) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.classList.add('hub__card-glyph');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', { heart: 'M12 20.5 4.2 12.6A4.6 4.6 0 0 1 10.7 6l1.3 1.3L13.3 6a4.6 4.6 0 0 1 6.5 6.6Z', share: 'M12 15V3m0 0L8 7m4-4 4 4M5 11v8h14v-8', external: 'M5 12h14m-6-6 6 6-6 6', chevron: 'm9 6 6 6-6 6' }[name]);
    svg.append(path);
    return svg;
  };
  const formatStamp = (value) => {
    try { return new Intl.DateTimeFormat('de-DE', { timeZone: 'Europe/Berlin', weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(value)); } catch { return ''; }
  };
  const platformLinks = (track) => {
    const query = [track?.artist, track?.title].filter(Boolean).join(' ');
    if (!query) return [];
    return [
      { label: 'Spotify', href: `https://open.spotify.com/search/${encodeURIComponent(query)}` },
      { label: 'YouTube', href: `https://www.youtube.com/results?search_query=${encodeURIComponent(query)}` },
      { label: 'Apple Music', href: `https://music.apple.com/de/search?term=${encodeURIComponent(query)}` }
    ];
  };
  const resolveTrack = (state) => {
    if (cardSource === 'history') {
      const item = (state.history || []).find((entry) => entry.track?.id === cardTrackId);
      if (item) return { track: { ...item.track, artworkUrl: item.artworkUrl }, show: item.playlistTitle, stamp: item.playedAt, stampLabel: 'Gespielt', kicker: 'Aus der Tracklist' };
      if (cardTrackSnapshot) return cardTrackSnapshot;
    }
    if (cardSource === 'favorites') {
      const item = (state.favorites || []).find((entry) => entry.id === cardTrackId);
      if (item) return { track: item, show: '', stamp: item.savedAt, stampLabel: 'Gespeichert', kicker: 'Favorit' };
      // Keep the chosen track visible even when its heart is removed in this dialog.
      if (cardTrackSnapshot) return { ...cardTrackSnapshot, kicker: 'Titel', stamp: '', stampLabel: '' };
    }
    if (!state.trackId) return null;
    return { track: { id: state.trackId, title: state.title, artist: state.artist, album: state.album, artworkUrl: state.artworkUrl }, show: state.program, stamp: '', stampLabel: '', kicker: 'Gerade läuft' };
  };
  const heartButton = (trackId, isFavorite, className) => {
    const button = el('button', className);
    button.type = 'button';
    button.dataset.asifRadioFavorite = '';
    button.dataset.asifRadioTrackId = trackId;
    button.setAttribute('aria-pressed', isFavorite ? 'true' : 'false');
    button.append(glyph('heart'));
    const label = el('span', '', isFavorite ? 'Gespeichert' : 'Speichern');
    label.dataset.asifRadioFavoriteLabel = '';
    button.append(label);
    return button;
  };
  const artworkNode = (url, size) => {
    const box = el('span', 'hub__card-art');
    const image = document.createElement('img');
    image.alt = '';
    image.width = size;
    image.height = size;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.src = url || (artNodes[0]?.getAttribute('src') || '');
    box.append(image);
    return box;
  };

  const renderCard = (state) => {
    if (!card || !cardBody) return;
    const favorites = state.favorites || [];
    const found = resolveTrack(state);
    if (found) cardTrackSnapshot = found;
    if (cardKicker) setText([cardKicker], found?.kicker || 'as.if.radio');
    const parts = [];

    if (found) {
      const { track } = found;
      const head = el('div', 'hub__card-track');
      head.append(artworkNode(track.artworkUrl, 640));
      const copy = el('div', 'hub__card-copy');
      const title = el('h3', 'hub__card-title', track.title || 'Unbekannter Titel');
      title.id = 'asif-track-card-title';
      title.tabIndex = -1;
      copy.append(title, el('p', 'hub__card-artist', track.artist || 'as.if.radio'));
      if (track.album && track.album !== track.title) copy.append(el('p', 'hub__card-meta', track.album));
      const facts = [found.show ? `Sendung: ${found.show}` : '', found.stamp ? `${found.stampLabel}: ${formatStamp(found.stamp)}` : ''].filter(Boolean).join(' · ');
      if (facts) copy.append(el('p', 'hub__card-meta', facts));
      head.append(copy);
      parts.push(head);

      const actions = el('div', 'hub__card-actions');
      if (track.id) actions.append(heartButton(track.id, favorites.some((item) => item.id === track.id), 'hub__card-button hub__card-button--heart'));
      const share = el('button', 'hub__card-button');
      share.type = 'button';
      share.dataset.asifRadioShare = '';
      share.append(glyph('share'));
      const shareLabel = el('span', '', 'Teilen');
      shareLabel.dataset.asifRadioShareLabel = '';
      share.append(shareLabel);
      actions.append(share);
      parts.push(actions);

      const links = el('nav', 'hub__card-links');
      links.setAttribute('aria-label', 'Auf Musikplattformen suchen');
      platformLinks(track).forEach((entry) => {
        const link = el('a', 'hub__card-link');
        link.href = entry.href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.append(el('span', '', entry.label));
        link.setAttribute('aria-label', `${entry.label} (öffnet in einem neuen Tab)`);
        links.append(link);
      });
      parts.push(links);
    } else {
      const title = el('h3', 'hub__card-title', 'Gerade kein Titel gemeldet.');
      title.id = 'asif-track-card-title';
      title.tabIndex = -1;
      parts.push(title);
    }

    const focused = cardBody.contains(document.activeElement) ? document.activeElement : null;
    const focusId = focused?.dataset?.asifRadioTrackId || '';
    cardBody.replaceChildren(...parts);
    if (focusId) cardBody.querySelector(`[data-asif-radio-track-id="${CSS.escape(focusId)}"]`)?.focus({ preventScroll: true });

  };

  const openCard = ({ trackId = '', source = 'current', opener = null } = {}) => {
    if (!card || typeof card.showModal !== 'function') return;
    cardTrackId = trackId;
    cardTrackSnapshot = null;
    cardSource = source;
    cardOpener = opener;
    closePanel();
    renderCard(window.AsIfRadio?.getState?.() || {});
    if (!card.open) card.showModal();
    window.requestAnimationFrame(() => cardBody?.querySelector('#asif-track-card-title')?.focus({ preventScroll: true }));
  };
  const closeCard = () => { if (card?.open) card.close(); };
  card?.addEventListener('close', () => {
    const opener = cardOpener;
    cardOpener = null;
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    else if (cardSource === 'favorites') document.getElementById('radio-favorites-title')?.focus({ preventScroll: true });
  });
  card?.addEventListener('click', (event) => {
    if (event.target === card) { closeCard(); return; }
    if (event.target.closest('[data-hub-card-close]')) { closeCard(); return; }
    if (event.target.closest('[data-asif-radio-favorite]') && cardTrackSnapshot?.track && window.AsIfRadio?.toggleFavorite) {
      event.preventDefault();
      event.stopPropagation();
      window.AsIfRadio.toggleFavorite(cardTrackSnapshot.track);
    }
  });
  card?.addEventListener('cancel', (event) => { event.preventDefault(); closeCard(); });
  qa('[data-hub-card-open]').forEach((button) => button.addEventListener('click', () => {
    openCard({ source: 'current', opener: button });
  }));
  // Radioseite und andere Skripte: document.dispatchEvent(new CustomEvent('asif:track:open', { detail: { trackId, source, opener } }))
  document.addEventListener('asif:track:open', (event) => openCard(event.detail || {}));
  document.addEventListener('asif:page:start', closeCard);

  /* --- Buehne im Bild? Dann zeigt die Leiste Marke und Sendung statt Titel --- */
  let stageObserver = null;
  const watchStage = () => {
    stageObserver?.disconnect();
    stageObserver = null;
    const stage = document.querySelector('[data-asif-radio-widget]');
    if (!stage || !('IntersectionObserver' in window)) { root.classList.remove('is-stage-visible'); return; }
    stageObserver = new IntersectionObserver((entries) => {
      // Beim weichen Seitentausch meldet die alte, schon entfernte Buehne
      // "unsichtbar". Das wuerde die Leiste kurz auf Titel umschalten.
      if (!stage.isConnected) return;
      root.classList.toggle('is-stage-visible', entries.some((entry) => entry.isIntersecting));
    }, { threshold: 0.2 });
    stageObserver.observe(stage);
  };
  /* --- Ereignisse ------------------------------------------------------ */

  let scrollFrame = 0;
  window.addEventListener('scroll', () => {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(() => {
      scrollFrame = 0;
      syncReveal();
    });
  }, { passive: true });

  window.addEventListener('resize', () => { revealHero = undefined; syncReveal(); }, { passive: true });
  window.addEventListener('asif:collection-change', () => { const state = window.AsIfRadio?.getState(); if (state) syncRadio(state); });
  window.addEventListener('asif:radio-state', (event) => syncRadio(event.detail));
  window.addEventListener('asif:radio-ready', () => { if (window.AsIfRadio?.getState) syncRadio(window.AsIfRadio.getState()); setupVolume(); });
  finePointer.addEventListener?.('change', syncVolumeVisibility);

  document.addEventListener('asif:page:start', () => { closePanel(); });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncProgress(window.AsIfRadio?.getState?.() || {}, true);
  });
  document.addEventListener('asif:page', () => {
    syncProgress(window.AsIfRadio?.getState?.() || {}, true);
    revealHero = undefined;
    harvestedFor = '';
    applyContext();
    applyMode();
    watchCommerce();
    watchStage();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (!(event.target instanceof Element) || !event.target.contains(root)) return;
    commerceObserver?.disconnect();
    stageObserver?.disconnect();
    consentObserver.disconnect();
    bodyObserver.disconnect();
    previewWatcher.disconnect();
    previewObserver?.disconnect();
    document.body.classList.remove('asif-message-hub-open');
    document.documentElement.classList.remove('asif-hub-bar');
  });

  /* --- Start ----------------------------------------------------------- */

  // Erster Zustand ohne Bewegung: sonst faehrt die Leiste auf der Radioseite
  // beim Laden aus der Ecke heraus.
  root.hidden = false;
  root.classList.add('is-instant');
  applyContext();
  observeConsent();
  syncConsent();
  syncPreview();
  syncRadio(window.AsIfRadio?.getState?.() || {});
  if (window.AsIfRadio) setupVolume();
  void root.offsetWidth;
  root.classList.remove('is-instant', 'is-morphing');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { watchCommerce(); watchStage(); }, { once: true });
  else { watchCommerce(); watchStage(); }
  syncReveal();
})();

/* 26.09.2026 Pierre: schwebende Player-Karte, zweite Runde. Solange die Buehne
   im Bild ist und nichts laeuft, steht links die Aufforderung ("Radio an",
   "Weiterhoeren", "Erneut versuchen") statt Titel und Artist. Der Text kommt
   aus derselben Quelle wie frueher die Beschriftung im Knopf. Tippen auf die
   Aufforderung startet das Radio, sonst oeffnet der Titel wie gewohnt die
   Titelkarte. Gestaltung und Uebergang: Block am Ende von asif-hub.css. */
(() => {
  const root = document.querySelector('[data-asif-hub]');
  const bar = root && root.querySelector('[data-hub-bar]');
  const play = root && root.querySelector('[data-hub-play]');
  const label = root && root.querySelector('[data-hub-play-label]');
  const launcher = root && root.querySelector('#asif-hub-launcher');
  const promptTitle = root && root.querySelector('[data-hub-prompt-title]');
  const promptSub = root && root.querySelector('[data-hub-prompt-sub]');
  // Knopfzustand -> Text links. Pierre 26.09.: nicht "Radio an", nicht cheesy.
  const MARK = '<span class="asif-wordmark">as.if.radio</span>';
  const PROMPTS = {
    'Radio an': ['Live hören', `${MARK}, rund um die Uhr`],
    'Weiterhören': ['Weiterhören', `${MARK}, live`],
    'Erneut versuchen': ['Erneut versuchen', 'Die Verbindung ist abgerissen']
  };
  if (!bar || !play || !launcher) return;
  // Den Namen des Titels setzt asif-hub.js laufend; hier nur merken und im
  // Aufforderungs-Zustand voruebergehend ersetzen.
  let hubLabel = launcher.getAttribute('aria-label') || 'Titelkarte öffnen';
  let promptLabel = '';
  let frame = 0;
  const sync = () => {
    frame = 0;
    const text = label && !label.hidden ? label.textContent.trim() : '';
    const prompt = Boolean(text) && root.classList.contains('is-stage-visible');
    if (prompt) {
      const [title, sub] = PROMPTS[text] || [text, ''];
      if (promptTitle && promptTitle.textContent !== title) promptTitle.textContent = title;
      if (promptSub && promptSub.dataset.key !== text) { promptSub.dataset.key = text; promptSub.innerHTML = sub; }
    }
    if (root.classList.contains('is-prompt') !== prompt) root.classList.toggle('is-prompt', prompt);
    promptLabel = prompt ? (PROMPTS[text] || [text])[0] : '';
    const name = prompt ? (PROMPTS[text] || [text])[0] : hubLabel;
    if (launcher.getAttribute('aria-label') !== name) launcher.setAttribute('aria-label', name);
    if (prompt) launcher.removeAttribute('aria-haspopup'); else launcher.setAttribute('aria-haspopup', 'dialog');
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
  // Titeldaten da? Erst dann zeigt die Karte Titel und Cover.
  const syncMeta = (state) => {
    const meta = Boolean(state && state.metadataStatus && state.metadataStatus !== 'loading');
    if (root.classList.contains('is-meta') !== meta) root.classList.toggle('is-meta', meta);
  };
  window.addEventListener('asif:radio-state', (event) => syncMeta(event.detail));
  window.addEventListener('asif:radio-ready', (event) => syncMeta(event.detail));
  syncMeta(window.AsIfRadio?.getState?.());
  // Buehne im Bild? Sofort entscheiden, nicht erst, wenn der Beobachter meldet.
  // Sonst blitzt oben auf der Radioseite kurz Titel und Cover statt der Aufforderung.
  const stageNow = () => {
    const stage = document.querySelector('[data-asif-radio-widget]');
    if (!stage) return;
    const rect = stage.getBoundingClientRect();
    const visible = rect.bottom > 0 && rect.top < window.innerHeight;
    if (visible) root.classList.add('is-stage-visible');
  };
  stageNow();
  document.addEventListener('asif:page', stageNow);
  new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['class'] });
  if (label) new MutationObserver(schedule).observe(label, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });
  new MutationObserver(() => {
    const value = launcher.getAttribute('aria-label') || '';
    if (value && value !== promptLabel) { hubLabel = value; if (promptLabel) schedule(); }
  }).observe(launcher, { attributes: true, attributeFilter: ['aria-label'] });
  launcher.addEventListener('click', (event) => {
    if (!root.classList.contains('is-prompt')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    play.click();
  }, true);
  sync();
})();

/* 26.09.2026 Pierre: Cover (Platte, Hintergrund der Buehne, Player) erst
   zeigen, wenn das echte Bild geladen ist. Aendert sich die Adresse, gilt es
   bis zum naechsten "load" als nicht bereit. Das Ersatzbild zaehlt nie. */
(() => {
  const SELECTOR = '[data-asif-radio-art], [data-stage-atmosphere], [data-hub-art]';
  const check = (img) => {
    const src = img.getAttribute('src') || '';
    const ready = Boolean(src) && !src.includes('og-radio-square') && img.complete && img.naturalWidth > 0 && (img.currentSrc || img.src) === img.src;
    if (img.hasAttribute('data-art-ready') !== ready) img.toggleAttribute('data-art-ready', ready);
  };
  const scan = () => document.querySelectorAll(SELECTOR).forEach((img) => { check(img); watch(img); });
  const watched = new WeakSet();
  const srcObserver = new MutationObserver((records) => records.forEach((r) => check(r.target)));
  const watch = (img) => { if (watched.has(img)) return; watched.add(img); srcObserver.observe(img, { attributes: true, attributeFilter: ['src'] }); };
  document.addEventListener('load', (event) => { const t = event.target; if (t && t.matches && t.matches(SELECTOR)) check(t); }, true);
  document.addEventListener('error', (event) => { const t = event.target; if (t && t.matches && t.matches(SELECTOR)) check(t); }, true);
  document.addEventListener('asif:page', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();

